var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.711 1.388h-.516v-.68a.704.704 0 0 0-.7-.708c-.387 0-.7.317-.7.708v.68h-5.6v-.68a.704.704 0 0 0-.7-.708c-.387 0-.7.317-.7.708v.68h-.506C1.027 1.388 0 2.426 0 3.703v8.982C0 13.962 1.027 15 2.29 15h9.42c1.263 0 2.29-1.038 2.29-2.315V3.703c0-1.277-1.026-2.315-2.289-2.315ZM2.29 2.804h.505v.343c0 .392.313.708.7.708.387 0 .7-.316.7-.708v-.343h5.6v.343c0 .392.314.708.7.708.388 0 .7-.316.7-.708v-.343h.517c.49 0 .889.403.889.9v1.959h-11.2v-1.96c0-.495.399-.9.889-.9Zm9.421 10.78H2.29a.896.896 0 0 1-.89-.899V7.078h11.2v5.607c0 .496-.399.9-.889.9Z",
    fill: "currentColor"
  })));
};
export default SvgCalendar;